import apiClient from './api.client';

const MercadoPagoService = {
  getIntegration: async (accountId) => {
    const { data } = await apiClient.get(`/account/${accountId}/integrations/mercado-pago`);
    return data;
  },

  saveIntegration: async (accountId, payload) => {
    const { data } = await apiClient.put(`/account/${accountId}/integrations/mercado-pago`, payload);
    return data;
  },

  removeIntegration: async (accountId) => {
    const { data } = await apiClient.delete(`/account/${accountId}/integrations/mercado-pago`);
    return data;
  },
};

export default MercadoPagoService;
